module.exports = __webpack_public_path__ + "static/media/PlaceholderCup.330c1016.png";